import { render, staticRenderFns } from "./iSwitch.vue?vue&type=template&id=383e10a0&scoped=true&"
import script from "./iSwitch.vue?vue&type=script&lang=js&"
export * from "./iSwitch.vue?vue&type=script&lang=js&"
import style0 from "./iSwitch.vue?vue&type=style&index=0&id=383e10a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e10a0",
  null
  
)

export default component.exports